import React from "react";

/**
 * Loading and empty rows for data tables. Both render as a single full-width
 * cell so the message is centred against the *table*, not against whichever
 * column it happened to land in — that mis-centring was why the "No Pending
 * KYC" block sat off to the left of the card.
 */

export const TableLoading = ({ colSpan, label = "Loading…" }) => (
  <tr className="table-state-row">
    <td colSpan={colSpan}>
      <div className="table-state">
        <span className="spinner-border text-primary" role="status" />
        <p className="table-state__text">{label}</p>
      </div>
    </td>
  </tr>
);

export const TableEmpty = ({ colSpan, icon, title, message }) => (
  <tr className="table-state-row">
    <td colSpan={colSpan}>
      <div className="table-state">
        {icon ? (
          <span className="table-state__icon" aria-hidden="true">
            {icon}
          </span>
        ) : null}
        {title ? <h3 className="table-state__title">{title}</h3> : null}
        {message ? <p className="table-state__text">{message}</p> : null}
      </div>
    </td>
  </tr>
);

export default { TableLoading, TableEmpty };
